<div class="ipm-container empty-list">
    <ng-container *ngIf="isShowIcon">
        <img priority src="./assets/imgs/sub-menu/empty-cart.svg" alt="empty-image" loading="lazy" *ngIf="isShowEmptyFirstImage && !messageType else secondImageSection">
        <ng-template #secondImageSection>
            <img priority src="./assets/imgs/icons/empty_data_icon.svg" class="imp-section-library" alt="empty-image" loading="lazy" *ngIf="messageType === 'custom'">
            <img priority src="./assets/imgs/empty-icon.png"  class="imp-section-library" alt="empty-image" loading="lazy" *ngIf="!messageType">
        </ng-template>
    </ng-container>
    <span>{{emptyMessage}}</span>
    <span class="sub-message-show"  *ngIf="subMessage">{{subMessage}}</span>
    <button class="action-button" (click)="gotoPageName()" *ngIf="isShowButton">{{buttonName}}</button>
</div>
